<template>
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link class="navbar-item brand has-text-weight-bold is-size-4 is-size-5-mobile" to="/">NTHUAAGC</router-link>

      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navMenu" v-on:click="navToggle">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navMenu" class="navbar-menu">
      <div class="navbar-end">
        <router-link class="navbar-item" to='/about'>
          關於本會
        </router-link>
        <router-link class="navbar-item" to='/events'>
          活動新聞
        </router-link>
        <router-link class="navbar-item" to='/join-us'>
          入會流程
        </router-link>
        <router-link class="navbar-item" to='/resources'>
          相關資源
        </router-link>
      </div>

    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  methods: {
    navToggle() {
      const burger = document.querySelector('.burger');
      const items = document.querySelectorAll('.navbar-item');
      const nav = document.querySelector(`#${burger.dataset.target}`);

      burger.classList.toggle('is-active');
      nav.classList.toggle('is-active');

      for (let i = 0; i < items.length; i += 1) {
        items[i].addEventListener('click', () => {
          burger.classList.remove('is-active');
          nav.classList.remove('is-active');
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.brand {
  color: #7F1084;
}

.navbar {
  border-top: 0.2rem solid #7F1084;
}

.router-link-active {
  color: #7F1084;
  font-weight: 500;
}

</style>
